export const dataHooks = {
  line: 'skeleton-line',
  chunk: 'skeleton-chunk',
};
